import axios, { AxiosPromise, AxiosRequestConfig } from 'axios'

export class ImportarCidadao {
  importar(formData: FormData, municipioId: ID, config?: AxiosRequestConfig): AxiosPromise<void> {
    return axios.post('/api/importarcidadao', formData, config)
  }
}
